<div class="flex w-full items-center overflow-hidden">
  <app-initials-avatar [avatarId]="me?.avatarId" [user]="{name: me?.name}" [width]="40" [textSize]="'text-base'"></app-initials-avatar>
  <div class="ltr:ml-2 rtl:mr-2 rtl:text-right flex flex-col w-full overflow-hidden">
    <div class="text-base font-semibold truncate">{{ me?.name }}</div>
    <div class="text-sm user__role-text mt-0.5">{{ me?.companyRole }}</div>
  </div>
</div>
